import { createContext, useContext } from "react";

export type Status = "error" | "processing" | "ready";

export type Filter<T> = (data: T[]) => T[];

export type FilterSet<T> = {
  id: string;
  filters: Filter<T>[];
  operator: "and" | "or";
  metadata?: unknown;
};

type Processor<T> = (items: readonly T[], value: string, options: Record<string, unknown>) => T[];

type SearchContext<T> = {
  source: T[];
  filteredData: T[];
  status: Status;
  results?: T[];
  processInput: (processor: Processor<T>, input: string, options: Record<string, unknown>) => void;
  reset: () => void;
};

export const SearchContext = createContext<SearchContext<any> | undefined>(undefined);

export const useSearch = <T>() => {
  const context = useContext(SearchContext as ReturnType<typeof createContext<SearchContext<T> | undefined>>);

  if (!context) throw new Error(`Expected "SearchFilterContext.Provider" in component tree.`);

  return context;
};
